<p class="small text-muted font-italic fadeIn" *ngIf="rows?.length === 0">{{ 'COMMON.EMPTY' | translate }}</p>